import { render, staticRenderFns } from "./SimpleMessage.vue?vue&type=template&id=54af7932&scoped=true&"
import script from "./SimpleMessage.vue?vue&type=script&lang=js&"
export * from "./SimpleMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54af7932",
  null
  
)

export default component.exports